import React, { useState } from 'react'
import { CouponDetailPageProps } from 'src/pages/CouponDetailPage/index'
import CouponDetailPrimaryInfo from 'src/pages/CouponDetailPage/_components/CouponDetailPrimaryInfo'
import UnderLineTab from 'src/components/common/UnderLineTab'
import { Container } from 'src/components/common/Container'
import MixedHtmlData from 'src/components/common/MixedHtmlData'
import RenderIf from 'src/components/common/RenderIf'
import StarIcon from 'src/components/common/StarIcon'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import useParamsType from 'src/hooks/useParamsType.hook'
import { AlwaysCouponDetailSpace } from 'src/types/api'
import styled from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import Accordion from 'src/components/common/Accordion'
import gift_btn_focus_gif from 'src/assets/images/gift/gift_btn_focus.gif'

type CouponDetailUnderLineType = 0 | 1

const CouponDetailPageView = (props: CouponDetailPageProps) => {
  const { couponDetailTabData, favoriteUpdateHandler, purchaseValidCheckSubmit, couponDetailData } =
    props
  const { couponType } = useParamsType()
  const { Favorite } = couponDetailData as AlwaysCouponDetailSpace.Response
  const [activeTab, setActiveTab] = useState<CouponDetailUnderLineType>(0)

  return (
    <Container $option="flex_column">
      <CouponDetailPrimaryInfo {...props} />
      <UnderLineTab<CouponDetailUnderLineType>
        items={[
          {
            text: '이용안내',
            contents: (
              <S.CouponDetailUsageWrap>
                <MixedHtmlData html={couponDetailData?.Introduction} />
              </S.CouponDetailUsageWrap>
            ),
            value: 0,
          },
          {
            text: '상세정보',
            contents: (
              <React.Fragment>
                <Accordion {...couponDetailTabData?.CouponInfo} type="big" />
                <Accordion {...couponDetailTabData?.RefundPolicy} type="big" />
                <Accordion {...couponDetailTabData?.PurchasePolicy} type="big" />
                <Accordion {...couponDetailTabData?.SellerInfo} type="big" />
              </React.Fragment>
            ),
            value: 1,
          },
        ]}
        state={{ activeTab, setActiveTab }}
      />
      <S.CouponDetailFixedContainer $option="flex_row">
        <RenderIf when={!Boolean(Number(couponType))}>
          <StarIcon
            size={48}
            active={Boolean(Favorite)}
            bgColor="var(--black-4)"
            onClickFn={() => favoriteUpdateHandler(Favorite)}
          />
        </RenderIf>
        <Container $option="flex_row" $column_gap="4px">
          <RenderIf when={!Boolean(Number(couponType))}>
            <S.GiftBtn onClick={() => purchaseValidCheckSubmit('gift')}>
              선물하기
              <S.GiftBtnFocus src={gift_btn_focus_gif} alt="선물하기" />
            </S.GiftBtn>
          </RenderIf>
          <Button
            option={ButtonOption3('active')}
            onClickFn={() => purchaseValidCheckSubmit('default')}
          >
            구매하기
          </Button>
        </Container>
      </S.CouponDetailFixedContainer>
    </Container>
  )
}
export default CouponDetailPageView

const S = {
  CouponDetailFixedContainer: styled(Container)`
    position: fixed;
    left: 50%;
    bottom: 0;
    justify-content: center;
    padding: 10px;
    margin-top: 68px;
    gap: 6px;
    border: none;
    transform: translate(-50%, 0%);
    background-color: var(--white);
    ${layoutMaxSize};
    z-index: ${ZIndex.BottomFixedContents};
  `,
  CouponDetailUsageWrap: styled(Container)`
    padding: 20px;
  `,
  GiftBtn: styled.button`
    ${ButtonOption3('outline')}
    position: relative;
  `,
  GiftBtnFocus: styled.img`
    position: absolute;
    left: calc(50% - 15px);
    top: -17px;
    width: 85px;
  `,
}
